<template>
  <div>
    <!-- Incident settings block -->
    <div class="card">
      <div class="card-body" id="update_schedule" :class="{'pr-0 pl-0': showOnTask}">
        <div class="float-right btn-sm btn-edit mr-0"
             @click="showFormFunction"
             qid="processing-role-edit-button"
             v-if="!showForm && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
        >
          <font-awesome-icon icon="pen"/>
        </div>
        <div class="mb-2">
          <h5 class="h5" v-if="!showOnTask">
            {{ $t('maintenance.incidents.incident_categories.schedule.title') }}
          </h5>
          <span v-if="!showOnTask">
            <span class="cursor-pointer task-label-open mr-2 ml-2 mr-2"
                  v-if="getTask('update_schedule')"
            >
              <UpdateSingleTaskModal
                  :task="myTasks[0]"
                  @reloadContent="reloadContent"
                  :editIcon="true"
                  name="123"
              ></UpdateSingleTaskModal>
            </span>
            <span v-if="getGuide('update_schedule')">
              <GuideButton :guide="getGuide('update_schedule')"></GuideButton>
            </span>
          </span>
        </div>

        <label class="mt-3">
          {{ $t('maintenance.incidents.incident_categories.schedule.due_after') }}
        </label>

        <div class="mw-500" v-if="showForm">

          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="edit-p-error"
          >
            {{ error }}
          </b-alert>

          <div class="row">
            <div class="col-sm-5">
              <b-form-input
                qid="business-risk-amount"
                type="number"
                max="365"
                min="0"
                :placeholder="$t('maintenance.incidents.incident_categories.schedule.amount_placeholder')"
                v-model="form.due_after"
              ></b-form-input>
            </div>
            <div class="col-sm-7">
              <multiselect
                  v-model="selectedInterval"
                  :options="intervals"
                  :placeholder="$t('maintenance.incidents.incident_categories.schedule.interval_placeholder')"
                  label="text"
                  track-by="value"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="create-p-form-pg"
              ></multiselect>
            </div>
          </div>
          <div class="text-right mt-3">
            <b-button class="ml-3"
                      variant="secondary"
                      @click="cancelForm"
                      qid="edit-pr-cancel-button"
            >
              {{ $t('activities.processing_type.cancel') }}
            </b-button>
            <b-button class="ml-2"
                      variant="success"
                      @click="formSubmit"
                      qid="edit-pr-submit-button"
            >
              {{ $t('activities.processing_type.submit') }}
            </b-button>
          </div>
        </div>
        <div v-if="!showForm">
          <div v-if="incident" class="mt-2">
            <div class="section-container">
              <span v-if="incident && incident.due_after">
                {{ incident.due_after }} {{ incident.due_after_interval }}
              </span>
              <p v-if="!incident.due_after" class="text-muted">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <div>
          &nbsp;
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import {config} from '@/config.js'
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'Responsibles',
    data: function() {
      return {
        incident: {},
        descriptionLength: config.descriptionLength,
        showFullDescription: false,
        showDescriptionInput: false,
        showPurposeInput: false,
        incidentEditDescription: '',
        showForm: false,
        anonymousCreator: '',
        selectedOrganization: [],
        organizations: [],
        selectedUsers: [],
        selectedInterval: [],
        users: [],

        error: '',
        myGuides: [],
        myTasks: [],
        intervals: [
          {text: this.$t('system.interval_seconds'), value: 'seconds'},
          {text: this.$t('system.interval_minutes'), value: 'minutes'},
          {text: this.$t('system.interval_hours'), value: 'hours'},
          {text: this.$t('system.interval_days'), value: 'days'},
          {text: this.$t('system.interval_months'), value: 'months'},
          {text: this.$t('system.interval_years'), value: 'years'}
        ],
        form: {
          due_after: '',
          due_after_interval: ''
        }
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      submitForm: {},
      task: {}
    },
    components: {
      Avatar,
      UpdateSingleTaskModal,
      GuideButton
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.incident.id && this.$store.state.updatedObject.who_am_i == this.incident.who_am_i) {
              this.incident = this.$store.state.updatedObject
            }
          }
          this.loadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_schedule')
        }
      },
      object: function (value) {
        this.incident = value

        if (this.showOnTask && !this.incident.description) {
          this.incidentEditDescription = ''
          this.showDescriptionInput = true;
        }

        if (this.showOnTask && this.incident.description) {
          this.showDescriptionInput = false;
        }

        this.loadTasks('update_schedule');
      },
      submitForm: function (value) {
        if (value) {
          if (this.showDescriptionInput) {
            this.formSubmit()
          }
        }
      }
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadContent()
        this.loadTasks('update_schedule');
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.incident.who_am_i,
              model_id: this.incident.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'incident_categories.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Incident' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: language,
            type: 'Incident',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      showFormFunction() {
        this.showForm = true;
        this.error = ''
        let self = this;

        this.selectedInterval = []
        if (this.incident.due_after_interval) {
          self.selectedInterval = _.find(self.intervals, function(item) {
            if(item.value === self.incident.due_after_interval){
              return item
            }
          });
        }

        this.form.due_after = this.incident.due_after;
      },
      formSubmit() {
        let self = this;

        if (this.selectedInterval && this.selectedInterval.value) {
          this.form.due_after_interval = this.selectedInterval.value
        }

        if (this.form.due_after && this.selectedInterval && this.selectedInterval.value) {
          piincHttp.put('incident-categories/' + this.incident.slug, this.form).then(function(response) {
            self.incident = response.data;
            self.showForm = false;
            self.$store.commit('storeUpdateContent', self.incident);
            self.loadTasks('update_schedule');
            self.$toastr('success', self.$t('maintenance.incidents.incident_categories.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = this.$t('maintenance.incidents.incident_categories.create.due_after_error')
        }
      },
      cancelForm() {
        this.showForm = false;
      },
      loadContent() {
        let self = this;
        piincHttp.get('incident-categories/' + this.incident.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.incident = response.data;
        }, function() {});
      }
    },
    created () {
      this.incident = this.object;

      if (this.showOnTask && !this.incident.description) {
        this.showDescriptionInput = true;
      }

      if (this.showOnTask) {
        this.loadContent()
      }

      if (this.incident && this.incident.id) {
        this.loadTasks('update_schedule');
      }

      this.loadGuides('update_schedule');

    }
  }
</script>
